import apiService from 'apiService'
import React from 'react'
import { toast } from 'react-toastify'

export default function DisableUserIcon({ storeId, refreshTable }) {
    const handleClick = async () => {
        const payload = {
            enabled: 0
        }
        await apiService.put(`/stores/${storeId}`, payload)
        refreshTable(+Date.now())
        toast.success('Επιτυχής απενεργοποίηση καταστήματος!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            theme: 'colored'
        })
    }

    return <i title="Απενεργοποίηση Καταστήματος" className="fas fa-store-slash text-orange-500 mr-2" style={{ cursor: 'pointer' }} onClick={handleClick}></i>
}
